import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import LLMLoadingMessage from 'llm/loading/LLMLoadingMessage';
import {PURPLE_LIGHTEST} from 'ui-library/Colors';

export default function DataCaptureProgress(): JSX.Element {
  return (
    <div className={css(styles.progressContainer)}>
      <LLMLoadingMessage text="Processing your request..." fontSize={14} />
    </div>
  );
}

const styles = StyleSheet.create({
  progressContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    padding: '16px',
    gap: '8px',
    backgroundColor: PURPLE_LIGHTEST,
  },
});
